import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Meta(props) {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{props?.title}</title>
        <meta name="description" content={props?.description} />
        <meta name="keywords" content={props?.keywords} />
        <meta name="author" content={props?.author} />
        <meta property="og:title" content={props?.title} />
        <meta property="og:description" content={props?.description} />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_HOSTNAME}${props?.image}`}
        />
        <meta
          property="og:url"
          content={`${process.env.REACT_APP_HOSTNAME}/`}
        />
        <meta name="twitter:title" content={props?.twitterTitle} />
        <meta name="twitter:description" content={props?.twitterDescription} />
        <meta name="twitter:image" content={props?.twitterImage} />
        <meta name="twitter:card" content={props?.twitterCard} />
      </Helmet>
    </HelmetProvider>
  );
}
